const AboutSection = () => {
  return (
    <section id="nosotros" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              <strong>Servicios del hogar</strong> en toda Gran Canaria
            </h2>
            <p className="text-lg text-gray-600 mb-6 leading-relaxed">
              En ayudadomiciliogc.es sabemos lo importante que es tu hogar. Por eso ofrecemos servicios profesionales de limpieza, mantenimiento y cuidado adaptados a las necesidades de cada familia en la isla de Gran Canaria.
            </p>
            <p className="text-lg text-gray-600 mb-8 leading-relaxed">
              Con más de 8 años de experiencia en servicios domiciliarios en Gran Canaria, nos hemos ganado la confianza de miles de hogares que buscan calidad, profesionalidad y tranquilidad.
            </p>

            <div className="space-y-4 mb-8">
              <div className="flex items-start space-x-3">
                <div className="w-6 h-6 flex items-center justify-center bg-teal-500 rounded-full flex-shrink-0 mt-1">
                  <i className="ri-check-line text-white text-sm"></i>
                </div>
                <p className="text-gray-700">
                  <strong>Equipo profesional certificado</strong> con formación especializada en servicios del hogar
                </p>
              </div>
              <div className="flex items-start space-x-3">
                <div className="w-6 h-6 flex items-center justify-center bg-teal-500 rounded-full flex-shrink-0 mt-1">
                  <i className="ri-check-line text-white text-sm"></i>
                </div>
                <p className="text-gray-700">
                  <strong>Servicio en toda la isla</strong> desde Las Palmas hasta Maspalomas y todos los municipios
                </p>
              </div>
              <div className="flex items-start space-x-3">
                <div className="w-6 h-6 flex items-center justify-center bg-teal-500 rounded-full flex-shrink-0 mt-1">
                  <i className="ri-check-line text-white text-sm"></i>
                </div>
                <p className="text-gray-700">
                  <strong>Flexibilidad total</strong> nos adaptamos a tus horarios y necesidades específicas
                </p>
              </div>
            </div>

            <a
              href="#contacto"
              className="inline-flex items-center bg-teal-500 text-white px-8 py-3.5 rounded-full text-base font-semibold hover:bg-teal-600 transition-all transform hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer"
            >
              <span>Descubre nuestros servicios</span>
              <i className="ri-arrow-right-line ml-2"></i>
            </a>
          </div>

          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <div className="w-full h-[600px]">
                <img
                  src="https://public.readdy.ai/ai/img_res/c4c42e7a4ed67c252a9bcdb2ea7cafef.jpg"
                  alt="Equipo profesional de ayudadomiciliogc.es en Gran Canaria"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>
            </div>

            <div className="absolute -bottom-6 -left-6 bg-white rounded-xl shadow-xl p-6 max-w-xs">
              <div className="flex items-center space-x-4">
                <div className="w-12 h-12 flex items-center justify-center bg-teal-500/10 rounded-full">
                  <i className="ri-shield-check-line text-2xl text-teal-500"></i>
                </div>
                <div>
                  <div className="text-2xl font-bold text-gray-900">100%</div>
                  <div className="text-sm text-gray-600">Garantía de calidad</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;